export interface PracticeMatchState{roundIndex:number;scores:{red:number;blue:number}}
export function undoFailedPracticePoint(state:PracticeMatchState):PracticeMatchState{
 return{roundIndex:state.roundIndex,scores:{red:state.scores.red,blue:Math.max(0,state.scores.blue-1)}};
}
